import React from "react";
import Marquee from "react-fast-marquee";
import './Trusted.css'

function Trusted() {
  return (
    <div>
        <div className="trusted-section">
            <div className="container">
                <div className="trusted-content">
                    <p className="text">Trusted by fast-growing companies worldwide</p>
                     <Marquee speed={50} gradientColor="white" gradient={true} gradientWidth={80}>

                        <div className="trustee-logo">
                            
                            <div className="image-wrapper"> <img src="./images/gtb-trusted.svg" alt="" /> </div> 
                            <div className="image-wrapper"> <img src="./images/stanbic-trusted.svg" alt="" /></div> 
                            <div className="image-wrapper">  <img src="./images/sterling-trusted.svg" alt="" /></div> 
                            <div className="image-wrapper"> <img src="./images/access-trusted.svg" alt="" /> </div> 
                            <div className="image-wrapper"> <img src="./images/heritage-trusted.svg" alt="" /> </div> 
                            <div className="image-wrapper"> <img src="./images/firstbank-trusted.svg" alt="" /> </div> 

                        </div>
                    </Marquee>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Trusted
